// extracted by mini-css-extract-plugin
export default {"button":"admin-button_button__v9n+9","default":"admin-button_default__ZRiLJ","outline":"admin-button_outline__tQZsW","small":"admin-button_small__lJ7iI"};